(function () {
  if (window.__bvtMegaMenu) return;
  window.__bvtMegaMenu = true;

  var HOVER_DELAY = 70; // ms, stops flicker when sweeping down the lists
  var SWAP_DELAY = 120; // ms, matches the image fade-out
  var timer = null;
  var preloaded = new WeakSet();

  function getMenu(target) {
    return target && target.closest ? target.closest('[data-mm]') : null;
  }

  function preload(menu) {
    if (preloaded.has(menu)) return;
    preloaded.add(menu);
    menu.querySelectorAll('[data-prod-image],[data-life-image],[data-preview-image]').forEach(function (el) {
      ['prodImage', 'lifeImage', 'previewImage'].forEach(function (key) {
        if (el.dataset[key]) {
          new Image().src = el.dataset[key];
        }
      });
    });
  }

  function setImage(slot, src, url) {
    if (!slot || !src) return;
    if (url) slot.setAttribute('href', url);
    var img = slot.querySelector('img');
    var current = slot.__want || img.getAttribute('src');
    if (current === src) return;
    slot.__want = src;
    clearTimeout(slot.__swap);
    img.classList.add('is-swapping');
    slot.__swap = setTimeout(function () {
      img.setAttribute('src', src);
      img.classList.remove('is-swapping');
    }, SWAP_DELAY);
  }

  // Fills a caption (title and, optionally, price) under an image.
  // custom = true when the title is a hand-written Menu label, shown exactly as typed.
  function setCaption(cap, title, price, custom) {
    if (!cap) return;
    var t = cap.querySelector('[data-cap-title]');
    var p = cap.querySelector('[data-cap-price]');
    if (t) t.textContent = title || '';
    if (p) p.textContent = price || '';
    cap.classList.toggle('mm__cap--custom', !!custom);
  }

  // Marks one column 2 item (and its column 3 product list) as active
  function activateSub(menu, key, index, withImages) {
    var panel = menu.querySelector('[data-mm-panel="' + key + '"]');
    if (!panel) return;

    var active = null;
    panel.querySelectorAll('[data-mm-sub]').forEach(function (el) {
      var on = el.getAttribute('data-mm-sub') === String(index);
      el.classList.toggle('is-active', on);
      if (on) active = el;
    });

    menu.querySelectorAll('[data-mm-third]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-mm-third') === key + '-' + index);
    });

    if (withImages && active) {
      var primary = menu.querySelector('[data-mm-link="' + key + '"]');
      var ownLife = active.getAttribute('data-life-image');
      setImage(menu.querySelector('[data-mm-product]'), active.getAttribute('data-preview-image'), active.getAttribute('data-preview-url'));
      if (active.getAttribute('data-preview-image')) {
        setCaption(
          menu.querySelector('[data-mm-product-cap]'),
          active.getAttribute('data-preview-title'),
          active.getAttribute('data-preview-price'),
          active.hasAttribute('data-preview-custom')
        );
      }
      setImage(
        menu.querySelector('[data-mm-life]'),
        ownLife || (primary && primary.getAttribute('data-life-image')),
        ownLife ? active.getAttribute('data-preview-url') : primary && primary.getAttribute('data-life-url')
      );
      setCaption(
        menu.querySelector('[data-mm-life-cap]'),
        ownLife ? active.getAttribute('data-life-caption') : primary && primary.getAttribute('data-life-caption'),
        ''
      );
    }
  }

  // Marks one column 1 item active and resets everything to its defaults
  function activate(menu, key, force) {
    key = String(key);
    if (!force && menu.__active === key) return;
    menu.__active = key;

    menu.querySelectorAll('[data-mm-link]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-mm-link') === key);
    });
    menu.querySelectorAll('[data-mm-panel]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-mm-panel') === key);
    });

    var link = menu.querySelector('[data-mm-link="' + key + '"]');
    if (!link) return;
    setImage(menu.querySelector('[data-mm-product]'), link.getAttribute('data-prod-image'), link.getAttribute('data-prod-url'));
    setCaption(
      menu.querySelector('[data-mm-product-cap]'),
      link.getAttribute('data-prod-title'),
      link.getAttribute('data-prod-price'),
      link.hasAttribute('data-prod-custom')
    );
    setImage(menu.querySelector('[data-mm-life]'), link.getAttribute('data-life-image'), link.getAttribute('data-life-url'));
    setCaption(menu.querySelector('[data-mm-life-cap]'), link.getAttribute('data-life-caption'), '');
    activateSub(menu, key, 0, false);
  }

  function handle(menu, target) {
    var primary = target.closest('[data-mm-link]');
    var sub = target.closest('[data-mm-sub]');
    var item = target.closest('.mm__item');

    if (primary) {
      activate(menu, primary.getAttribute('data-mm-link'));
    } else if (sub) {
      var panel = sub.closest('[data-mm-panel]');
      if (panel) activateSub(menu, panel.getAttribute('data-mm-panel'), sub.getAttribute('data-mm-sub'), true);
    } else if (item) {
      setImage(menu.querySelector('[data-mm-product]'), item.getAttribute('data-preview-image'), item.getAttribute('data-preview-url'));
      if (item.getAttribute('data-preview-image')) {
        setCaption(
          menu.querySelector('[data-mm-product-cap]'),
          item.getAttribute('data-preview-title'),
          item.getAttribute('data-preview-price'),
          item.hasAttribute('data-preview-custom')
        );
      }
    }
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var menu = getMenu(e.target);
    if (!menu) return;

    preload(menu);
    if (!e.target.closest('[data-mm-link],[data-mm-sub],.mm__item')) return;

    clearTimeout(timer);
    var target = e.target;
    timer = setTimeout(function () {
      handle(menu, target);
    }, HOVER_DELAY);
  });

  document.addEventListener('pointerout', function (e) {
    var menu = getMenu(e.target);
    if (!menu || menu.contains(e.relatedTarget)) return;
    clearTimeout(timer);
    activate(menu, 0, true);
  });

  // Keyboard users get the same behaviour as mouse users
  document.addEventListener('focusin', function (e) {
    var menu = getMenu(e.target);
    if (!menu) return;
    preload(menu);
    handle(menu, e.target);
  });

  document.addEventListener('focusout', function (e) {
    var menu = getMenu(e.target);
    if (!menu || menu.contains(e.relatedTarget)) return;
    activate(menu, 0, true);
  });

  document.addEventListener('keydown', function (e) {
    var menu = getMenu(e.target);
    if (!menu) return;

    var group = e.target.closest('.mm__primary, .mm__panel, .mm__list');
    if (!group) return;

    var inPrimary = group.classList.contains('mm__primary');
    var inPanel = group.classList.contains('mm__panel');
    var target = null;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var all = Array.prototype.slice.call(group.querySelectorAll('a'));
      target = all[all.indexOf(e.target) + (e.key === 'ArrowDown' ? 1 : -1)];
    } else if (e.key === 'ArrowRight') {
      if (inPrimary) target = menu.querySelector('.mm__panel.is-active a');
      else if (inPanel) target = menu.querySelector('.mm__list.is-active a');
    } else if (e.key === 'ArrowLeft') {
      if (inPanel) target = menu.querySelector('.mm__primary-link.is-active');
      else if (!inPrimary) target = menu.querySelector('.mm__sub.is-active');
    }

    if (target) {
      e.preventDefault();
      target.focus();
    }
  });
})();
